import * as Yup from "yup";
import { BaseInputProps } from "@jsq/ds/core";
import { createIndividualProfileSchema, IndividualProfileFormValues } from "./schemas";

export type IndividualProfile = Yup.InferType<ReturnType<typeof createIndividualProfileSchema>>;

export const defaultInitialValues = {
  firstName: "",
  middleName: "",
  lastName: "",
  dateOfBirth: "",
  identificationNumber: "",
  streetLine1: "",
  streetLine2: "",
  city: "",
  state: "",
  province: "",
  zip: "",
  country: "",
};

export interface IndividualFormProps extends BaseInputProps {
  /**
   * Callback function that is called when the continue button is clicked.
   */
  onContinue: (individualProfile: IndividualProfile) => Promise<void>;

  /**
   * Callback function that is called when the back button is clicked.
   */
  onBack: () => void;

  /**
   * The initial data for the form.
   */
  initialValues: IndividualProfileFormValues;
}
